import { useLanguage } from "@/contexts/LanguageContext";
import { Language } from "@/i18n/translations";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

const flags: Record<Language, string> = {
  en: "🇬🇧",
  nl: "🇳🇱",
  fr: "🇫🇷",
};

const labels: Record<Language, string> = {
  en: "English",
  nl: "Nederlands",
  fr: "Français",
};

interface LanguageSwitcherProps {
  variant?: "default" | "sidebar" | "sidebar-dark";
  className?: string;
}

export const LanguageSwitcher = ({ variant = "default", className }: LanguageSwitcherProps) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            "gap-2",
            variant === "sidebar" && "w-full justify-start text-muted-foreground hover:bg-muted hover:text-foreground",
            variant === "sidebar-dark" && "w-full justify-start text-blue-200 hover:bg-white/10 hover:text-white",
            className
          )}
        >
          <Globe className="h-4 w-4" />
          <span>{flags[language]}</span>
          <span className="text-sm">{labels[language]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[160px]">
        <DropdownMenuItem onClick={() => setLanguage("en")} className="gap-2">
          <span>{flags.en}</span>
          <span>{t.language.en}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage("nl")} className="gap-2">
          <span>{flags.nl}</span>
          <span>{t.language.nl}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage("fr")} className="gap-2">
          <span>{flags.fr}</span>
          <span>{t.language.fr}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};